import { useState } from "react";
import {
    Box,
    Button,
    Drawer,
    List,
    IconButton,
    ListItemButton,
    ListItemText,
    useMediaQuery,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { MenuIcon } from 'lucide-react';
import fullLogo from '../../Assets/Images/Company-fulllogo.png'

function Header() {
    const isMobile = useMediaQuery("(max-width:768px)");
    const [mobileOpen, setMobileOpen] = useState(false);
    const navigate = useNavigate();

    const desktopMenuItems = [
        { id: 1, label: "About", path: "/about" },
        { id: 2, label: "Why Choose Us", path: "/why-choose-us" },
        { id: 3, label: "Where We Build", path: "/where-we-build" },
        { id: 4, label: "Projects", path: "/gallery" },
        { id: 5, label: "Accessibility", path: "/accessibility" },
        { id: 6, label: "Contact Us", path: "/contact" },
    ];

    const handleNavigation = (item) => {
        if (item.path) {
            navigate(item.path);
        }
    };

    const renderMobileMenu = (items) =>
        items.map((item) => (
            <ListItemButton
                key={item.id}
                onClick={() => {
                    handleNavigation(item);
                    setMobileOpen(false);
                }}
            >
                <ListItemText className="text-main fs-16" primary={item.label} />
            </ListItemButton>
        ));

    const renderMenu = (item) => (
        <Button
            key={item.id}
            onClick={() => handleNavigation(item)}
            variant="text"
            sx={{
                mx: 1,
                textTransform: "none",
                fontWeight: 600,
                color: "#fff",
                transition: 'all 0.3s ease',
                "&:hover": {
                    color: "var(--primary-text-color)",
                    borderBottom:'2px solid var(--primary-text-color)',
                    borderRadius:0,
                    backgroundColor: "transparent",
                },
            }}
            className="fs-16 pb-2"

        >
            {item.label}
        </Button>
    );

    return (
        <Box
            height={'60px'}
            position={'sticky'}
            top={0}
            zIndex={99}
            justifyContent={{xs:"space-between", md:'space-around'}}
            className="header py-2 d-flex align-items-center  bg-dark-main"
        >
            {/* Logo */}
            <Box
                component="img"
                src={fullLogo} // replace with your logo path
                width={'150px'}
                onClick={()=>{navigate('/')}}
            />

            <div className="d-flex align-items-center header">
                {isMobile ? (
                    <>
                        <IconButton onClick={() => setMobileOpen(true)} color="inherit">
                            <MenuIcon style={{color: 'var(--primary-text-color)'}} />
                        </IconButton>

                        <Drawer
                            anchor="right"
                            open={mobileOpen}
                            onClose={() => setMobileOpen(false)}
                        >
                            <List sx={{ width: 260, mt: 2 }}>
                                {renderMobileMenu(desktopMenuItems)}
                            </List>
                        </Drawer>
                    </>
                ) : (
                    desktopMenuItems.map((item) => renderMenu(item))
                )}
            </div>
        </Box>
    );
}

export default Header;